<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-titlepage title-page" epub:type="titlepage" id="title-page">
<div class="title-page-title-subtitle-block">
<h1 class="title-page-title">The Throne of Saturn</h1>
<h2 class="title-page-subtitle">A Novel of Space and Politics</h2>
</div>
<div class="title-page-contributor-block">
<div class="title-page-contributor-primary-block">
<h2 class="title-page-contributor title-page-contributor-primary title-page-contributor-without-introduction"><span class="title-page-contributor-name">Allen Drury</span></h2>
</div>
<div class="title-page-contributor-secondary-block">
<h2 class="title-page-contributor title-page-contributor-secondary title-page-contributor-with-introduction"><span class="title-page-contributor-introduction">Foreword by</span> <span class="title-page-contributor-name">Doug Beason, PhD</span></h2>
</div>
</div>
<div class="publisher-block">
<div class="title-page-publisher-logo-block title-page-publisher-logo-aspect-square">
<div class="title-page-publisher-logo-size-container publisher-logo-width-500">
<img alt="WordFire Press" class="title-page-publisher-logo-image" src="images/wfp-logo-color-sq.jpg"/>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?44910767